export function getBrowserLanguage() {
  const language = navigator.language || navigator.userLanguage;
  const langCode = language ? language.split("-")[0] : "en";
  return langCode;
}
